import {
  CHOOSE,
  CODE,
  DROP,
  PACKAGE,
  VALIDATE,
  VOUCHER,
} from "../core/constants";

import ForBrands from "../components/ForBrands";
import HowItWorks from "../components/HowItWorks";
import Layout from "../components/Layout";
import PageContent from "../components/PageContent";
import React from "react";
import TakebackHero from "../components/TakebackHero";
import TakebackStats from "../components/TakebackStats";
import WhatHappens from "../components/WhatHappens";

function TakebackPage({ pageData, navItems, brands, globalData }) {
  const steps = [
    {
      text: pageData.chooseItem,
      icon: CHOOSE,
    },
    {
      text: pageData.package,
      icon: PACKAGE,
    },
    {
      text: pageData.dropParcel,
      icon: DROP,
    },
    {
      text: pageData.validate,
      icon: VALIDATE,
    },
    {
      text: pageData.voucher,
      icon: VOUCHER,
    },
    {
      text: pageData.insertCode,
      icon: CODE,
    },
  ];

  return (
    <Layout navItems={navItems} globalData={globalData}>
      <PageContent>
        <TakebackHero
          heading={pageData.heading}
          subheading={pageData.subheading}
          heroImage={pageData.heroImage}
        />
        <ForBrands
          brands={brands}
          heading={pageData.brandsHeading}
          text={pageData.brandsText}
        />
        <HowItWorks
          heading={pageData.howItWorksHeading}
          callout={pageData.howItWorksCallout}
          text={pageData.howItWorksText}
          steps={steps}
        />
        <WhatHappens
          heading={pageData.whatHappensHeading}
          text={pageData.whatHappensText}
          learnMore
        />
        <TakebackStats
          resale={pageData.resale}
          reuse={pageData.reuse}
          recycle={pageData.recycle}
          landfill={pageData.landfill}
        />
      </PageContent>
    </Layout>
  );
}

export default TakebackPage;
